const __import__ = file => () => import(`@/apps/${file}.vue`)

const routes = [
    {
        path: '/apps/plan',
        name: 'appsplan',
        component: __import__('plan/plan_page'),
        meta: {
            login: true,
            title: '计划日志 - 佑佐成长之路'
        }
    },
    {
        path: '/apps/plan/new',
        name: 'newplan',
        component: __import__('plan/plan_new'),
        meta: {
            login: true,
            title: '计划日志 - 新建计划'
        }
    },
    {
        path: '/apps/plan/notes',
        name: 'plannotes',
        component: __import__('plan/notes_page'),
        meta: {
            login: true,
            title: '计划日志 - 新建日志'
        }
    },
    {
        path: '/apps/notes/publish',
        name: 'note_publish',
        component: __import__('plan/publish'),
        meta: {
            login: true,
            title: '计划日志 - 新建行动笔记'
        }
    },
    {
        path: '/apps/plan/edit/:id',
        name: 'editplan',
        component: __import__('plan/edit'),
        meta: {
            login: true,
            title: '计划日志 - 编辑日志'
        }
    },
    {
        path: '/apps/plan/mobile_edit/:id',
        name: 'editmobileplan',
        component: __import__('plan/mobile_edit'),
        meta: {
            title: '计划日志 - 编辑日志'
        }
    },
    {
        path: '/apps/plan/:id',
        name: 'planinfo',
        component: __import__('plan/plan_info'),
        meta: {
            login: true,
            title: '计划日志 - 查看计划'
        }
    },
    {
        path: '/apps/plan/todo',
        name: 'todo',
        component: __import__('plan/todo'),
        meta: {
            login: true,
            title: '待办事项'
        }
    },
    {
        path: '/apps/plan/mobile/todo',
        name: 'mobiletodo',
        component: __import__('plan/mobile_todo'),
        meta: {
            title: '待办事项'
        }
    },
    {
        path: '/apps/mobile/plan',
        name: 'mobileplan',
        component: __import__('plan/plan_mobile_page'),
        meta: {
            title: '我的行动计划'
        }
    },
    {
        path: '/apps/plan/mobile/new',
        name: 'newmobileplan',
        component: __import__('plan/plan_mobile_new'),
        meta: {
            login: true,
            title: '新建行动计划'
        }
    },
    {
        path: '/apps/plan/mobile/info/:id',
        name: 'planmobileinfo',
        component: __import__('plan/plan_mobile_info'),
        meta: {
            login: true,
            title: '查看行动计划'
        }
    },
    {
        path: '/apps/plan/mobile/notes',
        name: 'planmobilenotes',
        component: __import__('plan/mobile_notes'),
        meta: {
            login: true,
            title: '计划日志 - 新建日志'
        }
    },
    {
        path: '/apps/notes/publish',
        name: 'note_publish',
        component: __import__('plan/publish'),
        meta: {
            login: true,
            title: '计划日志 - 新建行动笔记'
        }
    },
]

export default {
    namespaced: true,
    routes
}
